<template>
  <div class="panel">
    <header>
      <h4>Detalhes</h4>
      <div>
        <a href="#" class="calendarToggle" v-if="negociacao">
          <fa :icon="['far','calendar-days']" class="ic"/>
          <span></span>
        </a>
      </div>
    </header>
    <div class="panelGrid">
      <div :class="{ off: !negociacao }">
        <div>
          <template v-if="negociacao">
            <p>Parcela</p>
            <h2>10</h2>
          </template>
        </div>
        <div>
          <template v-if="negociacao">
            <h3>12</h3>
            <p>Total</p>
          </template>
        </div>
        <div>
          <template v-if="negociacao">
            <h4>R$ 198,45</h4>
            <p>Valor Parcela</p>
          </template>
        </div>
        <div>
          <template v-if="negociacao">
            <h3>20/06</h3>
            <p>Próxima Parcela</p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    negociacao: Object
  },
  data () {
    return {
      
    }
  },
  mounted () {

  }
}
</script>

<style lang="scss" scoped>
  .panel {
    margin-top: $hmg_large;

    > header {
      display: flex;
      align-items: center; justify-content: space-between;
      padding: 0 0 $hmg_mid $hmg_mid;

      h4 {
        margin: 0;
        line-height: 1;
      }
      .calendarToggle {
        display: flex;
        flex-direction: column;
        align-items: center; justify-content: center;
        width: 34px; height: 34px;
        flex-shrink: 0;
        font-size: 16px;
        position: relative;

        span {
          position: absolute; z-index: 1;
          width: 100%; height: 100%;
          top: 0; left: 0;
          border-radius: 100%;
          background-color: $color-success;
          transform-origin: center;
          @extend %transition_3o;
        }

        .ic {
          position: relative; z-index: 2;
          margin-top: -1px
        }

        &:hover {
          span {
            transform: scale(1.1);
          }
        }

        >div {

        }
      }
    }

    .panelGrid {
      width: 100%; padding-top: 82%;
      position: relative;
      @media screen and ( min-width: 1024px ) {
          padding-top: 200px;
      }

      > div {
        display: flex; gap: $hmg_mid;
        position: absolute;
        justify-content: space-between;
        top: 0; left: 0; width: 100%; height: 100%;

        @media screen and ( max-width: 1024px ) {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          grid-template-rows: repeat(10,1fr);
        }

        > div {
          border-radius: $border-radius;
          background-color: $azul-escuro-2;
          display: flex; flex-direction: column;
          align-items: center; justify-content: center;
          flex: 1; position: relative;
          @extend %transition_4e;

          p {
            margin: 0; padding: 0;
          }

          h2 {
            margin: 0; padding: 0;
            font-size: 3.5rem !important;
          }
          
          h3 {
            margin: 0; padding: 0;
            font-size: 2.5rem !important;
          }

          h4 {
            margin: 0; padding: 0;
            font-size: 2rem !important;
          }

          @media screen and ( max-width: 1024px ) {
            &:nth-child(1) {
              grid-column: 1;
              grid-row: 1 / span 6;
            }
            
            &:nth-child(2) {
              grid-column: 2;
              grid-row: 1 / span 4;
            }

            &:nth-child(3) {
              grid-column: 1;
              grid-row: 7 / span 4;
            }

            &:nth-child(4) {
              grid-column: 2;
              grid-row: 5 / span 6;
            }
          }
        }

        &.off {
          >div {
            opacity: .3;
          }
        }
      }
    }
  } 
</style>